import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import cn from 'classnames';
import { PapiUser } from '@wix/da-papi-types';
import UserAvatar from '@wix/da-shared-react/pkg/User/Avatar';
import BasicUsername from '@wix/da-shared-react/pkg/User/BasicUserName';

import s from './GiftRecipient.scss';

interface Props {
  user: PapiUser;
  className?: string;
  prefixClassName?: string;
  avatarSize?: number;
}

const GiftRecipient: FC<Props> = ({ user, className, prefixClassName, avatarSize = 24 }) => {
  const { t } = useTranslation();
  return (
    <div className={cn(s['root'], className)}>
      <span className={cn(s['prefix'], prefixClassName)}>
        {t('packagePicker.heroTable.header.gift.prefix')}
      </span>
      <UserAvatar className={s['avatar']} user={user} size={avatarSize} />
      <BasicUsername user={user} />
    </div>
  );
};
GiftRecipient.displayName = 'GiftRecipient';

export default GiftRecipient;
